/**
 * ParametroRelatorio
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {ResponseSerialize} from 'simpli-web-sdk'
import {RelatorioGeracao} from '@/model/resource/RelatorioGeracao'
import {ParametroRelatorioCollection} from '@/model/collection/ParametroRelatorioCollection'

/* TODO: review generated class */
export class ParametroRelatorio extends Resource {
  idParametroRelatorioPk: number = 0

  @ResponseSerialize(RelatorioGeracao)
  relatorioGeracao: RelatorioGeracao | null = null

  dateBy: string | null = null
  cnpjDestinatario: string | null = null
  cnpjEmbarcadorTransportador: string | null = null
  nroFiscal: string | null = null
  ocorrencia: number | null = null
  auditoria: number | null = null
  comMotorista: number | null = null
  idMotorista: number | null = null
  idStatus: number | null = null
  slaPendente: number | null = null
  cep: string | null = null
  uf: string | null = null
  cidade: string | null = null
  cte: string | null = null
  idOcorrencia: number | null = null
  start: string | null = null
  end: string | null = null

  get $id() {
    return this.idParametroRelatorioPk
  }
  set $id(val) {
    this.idParametroRelatorioPk = val
  }

  get idRelatorioGeracaoFk() {
    if (!this.relatorioGeracao) return 0
    return this.relatorioGeracao.$id
  }
  set idRelatorioGeracaoFk(val) {
    if (!this.relatorioGeracao) this.relatorioGeracao = new RelatorioGeracao()
    this.relatorioGeracao.$id = val
  }

  /**
   * Gets a instance of a given ID of ParametroRelatorio
   */
  async getParametroRelatorio(id: number) {
    return await Request.get(`/admin/parametro-relatorio/${id}`)
      .name('getParametroRelatorio')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of ParametroRelatorio
   */
  static async listParametroRelatorio(params: any) {
    return await Request.get(`/admin/parametro-relatorio`, {params})
      .name('listParametroRelatorio')
      .as(ParametroRelatorioCollection)
      .getData()
  }

  /**
   * Persists a new instance of ParametroRelatorio. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistParametroRelatorio() {
    return await Request.post(`/admin/parametro-relatorio`, this)
      .name('persistParametroRelatorio')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of ParametroRelatorio to use it in a CSV file
   */
  static async listCsvParametroRelatorio(params: any) {
    return await Request.get(`/admin/parametro-relatorio/csv`, {params})
      .name('listCsvParametroRelatorio')
      .as(ParametroRelatorioCollection)
      .getData()
  }
}
